import * as React from "react";
import { Component } from "react";
import { LoginGoLink } from "source/app/presentation/Login/Go/LoginGoLink";
import { defaultFingerprint } from "source/app/presentation/Login/Helpers/defaultFingerprint";
import { ILoginState } from "source/app/presentation/Login/Helpers/ILoginState";
import { LoginAsync } from "source/app/presentation/Login/Helpers/LoginAsync";
import { LoginAsLocalDevelopmentUser } from "source/app/presentation/Login/Helpers/LocalDevelopmentLoginAsync";
import { LoginWithPasskeyAsync } from "source/app/presentation/Login/Helpers/PasskeyAsync";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import Render from "source/app/presentation/Shared/Render";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { browserSupportsWebAuthn } from "@simplewebauthn/browser";
import { CanUseLocalDevelopmentSession } from "source/app/services/Authentication/ClientSession";
import * as styles from "./Login.css";

export default class Login extends Component<{}, ILoginState> {
    constructor(props: {}) {
        super(props);

        this.state = {
            fingerprint: defaultFingerprint,
            username: "",
            password: "",
            shouldRememberDevice: false,
            deviceName: "unknown device",
            totpToken: "",
            isWebAuthnSupported: false,
            isSecureContext: false,
            isPasskeyActionInProgress: false,
            shouldShowPasswordLogin: false,
        };
    }

    async componentDidMount() {
        this.setState({
            isWebAuthnSupported: browserSupportsWebAuthn(),
            isSecureContext: window.isSecureContext,
        });
        State.ShareClass(ESharedComponent.Login, this);
    }

    componentDidUpdate() {
        State.ShareClass(ESharedComponent.Login, this);
    }

    render() {
        const shouldShowPasskeyLogin =
            this.state.isWebAuthnSupported && this.state.username !== "";
        const shouldShowPasswordLogin =
            this.state.shouldShowPasswordLogin ||
            !this.state.isWebAuthnSupported;

        return (
            <div className={styles.main}>
                <div className={styles.title}>Login to Mastery</div>
                <div className={styles.form}>
                    <FormInput
                        type="text"
                        classes={styles.input}
                        placeholder="username"
                        onChange={(event) =>
                            this.setState({ username: event.target.value })
                        }
                        autocomplete="username webauthn"
                        minWidth="100%"
                        value={this.state.username}
                    />
                    <Render
                        id="passkeyLogin"
                        when={shouldShowPasskeyLogin}
                    >
                        <button
                            type="button"
                            className={styles.passkeyButton}
                            disabled={this.state.isPasskeyActionInProgress}
                            onClick={() => LoginWithPasskeyAsync(this)}
                        >
                            {this.state.isPasskeyActionInProgress
                                ? "Using passkey..."
                                : "Use Passkey"}
                        </button>
                    </Render>
                    <Render
                        id="passwordLoginToggle"
                        when={
                            this.state.isWebAuthnSupported &&
                            !this.state.shouldShowPasswordLogin
                        }
                    >
                        <button
                            type="button"
                            className={styles.fallbackButton}
                            onClick={() =>
                                this.setState({
                                    shouldShowPasswordLogin: true,
                                })
                            }
                        >
                            Use password + TOTP instead
                        </button>
                    </Render>
                    <Render
                        id="passkeyUnavailable"
                        when={
                            this.state.username !== "" &&
                            !this.state.isWebAuthnSupported &&
                            !this.state.isSecureContext
                        }
                    >
                        <div className={styles.passkeyUnavailable}>
                            Passkeys require HTTPS on iPhone
                        </div>
                    </Render>
                    <Render
                        id="passwordLogin"
                        when={shouldShowPasswordLogin}
                    >
                        <FormInput
                            type="password"
                            classes={styles.input}
                            placeholder="password"
                            onChange={(event) =>
                                this.setState({
                                    password: event.target.value,
                                })
                            }
                            onEnter={() => LoginAsync(this)}
                            value={this.state.password}
                        />
                        <FormInput
                            type="text"
                            classes={styles.input}
                            placeholder="totp token"
                            onChange={(event) =>
                                this.setState({
                                    totpToken: event.target.value,
                                })
                            }
                            maxWidth="150px"
                            value={this.state.totpToken}
                            onEnter={() => LoginAsync(this)}
                        />
                        <LoginGoLink Login={this} />
                    </Render>
                    {/* <DisplayRememberDevice Login={this} /> */}
                </div>
                {CanUseLocalDevelopmentSession() && (
                    <div style={{ marginTop: "18px", textAlign: "center" }}>
                        <button
                            type="button"
                            className={styles.fallbackButton}
                            onClick={() => LoginAsLocalDevelopmentUser(this)}
                        >
                            Sign in to local development server
                        </button>
                        <div style={{ marginTop: "6px", fontSize: "12px", opacity: 0.7 }}>
                            Development-only; uses the local database and no production credentials.
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
